import React from "react";
import "./LpDocTypes.css";
import LpDocTypesMain from "./LpDocTypesMain";
import LpDocTypesHead from "./LpDocTypesHead";
const LpDocTypes = () => {
  return (
    <div className="lpDocTypes-container" id="documents">
      <LpDocTypesHead />
      <LpDocTypesMain />
    </div>
  );
};

export default LpDocTypes;
